module.exports = "/assets/data/fef4155a229081c3dc44afc9abf9a3c2-KT18.data.json";